import { reactErrorHandler } from '@sentry/react'
import { StartClient } from '@tanstack/react-start/client'
import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'

// Explicit client entry overriding TanStack Start's implicit default: it wires
// Sentry's reactErrorHandler into React 19's root error callbacks so hydration
// and render errors are captured. Without this file Start emits a bare
// hydrateRoot with no Sentry capture.
startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<StartClient />
		</StrictMode>,
		{
			onCaughtError: reactErrorHandler(),
			onRecoverableError: reactErrorHandler(),
			onUncaughtError: reactErrorHandler()
		}
	)
})
